import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createButtonBlock,
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getColorOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import imageBackgroundPreview from "../../Sales/SalesBlock10/sales_block_10_image_placeholder_2.png";
import { secondaryBlockDefaultStyles } from "../constants";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock8",
  props: {
    backgroundImage: {
      id: uuidv4(),
      type: "circle-image-upload",
      prop: "other",
      value: {
        signed_id: "",
        placeholder: imageBackgroundPreview,
      },
    },
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Your Next Level of Success Awaits. Let's Start Today.",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
        createPBlock({
          text: "Join a network of ambitious leaders and take your career to the next level with expert coaching and a supportive community",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    buttons: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Schedule a Free Consultation",
          href: "#",
          buttonType: "secondaryButton",
        }),
        createButtonBlock({
          text: "Join the Community",
          href: "#",
          buttonType: "customButton",
          styles: {
            default: {
              color: getColorOptions(
                "var(--theme-website-primary-button-default-text-color)",
              ),
              backgroundColor: getBackgroundColorOptions({
                defaultValue: "transparent",
              }),
            },
          },
        }),
      ],
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Limited spots available. Applications close at the end of the month.",
          paragraphStyle: "p3",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue:
            "var(--theme-website-primary-button-hover-background-color)",
        }),
        padding: getPaddingOptions({
          defaultValue: secondaryBlockDefaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: secondaryBlockDefaultStyles.margin,
        }),
      },
    },
  },
};
